import { render } from "./FeedbackButton.vue?vue&type=template&id=08c79b2b&scoped=true"
import script from "./FeedbackButton.vue?vue&type=script&lang=js"
export * from "./FeedbackButton.vue?vue&type=script&lang=js"

import "./FeedbackButton.vue?vue&type=style&index=0&id=08c79b2b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c79b2b"]])

export default __exports__